export default __webpack_public_path__ + "static/media/cvod-pg.95e93a36.svg";